import { render, staticRenderFns } from "./ProductionDeliveryForm.vue?vue&type=template&id=10b5bd13&scoped=true"
import script from "./ProductionDeliveryForm.vue?vue&type=script&lang=js"
export * from "./ProductionDeliveryForm.vue?vue&type=script&lang=js"
import style0 from "./ProductionDeliveryForm.vue?vue&type=style&index=0&id=10b5bd13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b5bd13",
  null
  
)

export default component.exports